import { render, staticRenderFns } from "./SelfAssessmentAgilityTest.vue?vue&type=template&id=1508c471&scoped=true&"
import script from "./SelfAssessmentAgilityTest.vue?vue&type=script&lang=ts&"
export * from "./SelfAssessmentAgilityTest.vue?vue&type=script&lang=ts&"
import style0 from "./SelfAssessmentAgilityTest.vue?vue&type=style&index=0&id=1508c471&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508c471",
  null
  
)

export default component.exports